<!-- Template -->
<template>
  <div class="table-responsive gateway-table-menu ">
    <!-- Base Route List -->
    <b-table
      v-if="!activeHref"
      id="gateway-table"
      striped
      hover
      :items="gatewayInspectData"
      :sort-desc="true"
      :fields="gatewayInspectTableFields"
      @row-clicked="focusBaseHref"
      class="table table-hover m-0 align-middle"
      medium>
      <template #cell(proxyId)="data">
        <span v-bind:id="data.item.id + '-' + data.item.proxyId + '-proxyId'">
            {{data.value}}
        </span>
        <!-- WIP. For now no editing. WIP. -->
        <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.proxyId + '-proxyId', 'input')">
          <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/saveIcon.svg' />
          <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/edit.svg' />
        </a> -->
      </template>
      <template #cell(description)="data">
        <span v-bind:id="data.item.id + '-' + data.item.proxyId + '-description'">
            {{data.value}}
        </span>
        <!-- WIP. For now no editing. WIP. -->
        <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.proxyId + '-description', 'input')">
          <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/saveIcon.svg' />
          <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
          src='../../assets/images/edit.svg' />
        </a> -->
      </template>
      <template #cell(tools)="data">

      </template> 
    </b-table>
    <div v-if="activeHref && !addEndpoint">
      <b-table
          v-if="activeHref"
          id="gateway-table"
          striped
          hover
          :items="gatewayData"
          :sort-desc="true"
          :fields="gatewayTableFields"
          class="table table-hover m-0 align-middle"
          medium>
        <template #cell(method)="data">
          <span v-if="data.value.toUpperCase() === 'GET'" class="gateway__method-bubble gateway__get-bubble">GET</span>
          <span v-if="data.value.toUpperCase() === 'PATCH'" class="gateway__method-bubble gateway__patch-bubble">PATCH</span>
          <span v-if="data.value.toUpperCase() === 'PUT'" class="gateway__method-bubble gateway__put-bubble">PUT</span>
          <span v-if="data.value.toUpperCase() === 'POST'" class="gateway__method-bubble gateway__post-bubble">POST</span>
          <span v-if="data.value.toUpperCase() === 'DELETE'" class="gateway__method-bubble gateway__delete-bubble">DELETE</span>
          <!-- WIP. For now no editing. WIP. -->
          <!-- <img class="gateway__tool-button ml-1" v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-method', 'select', ['GET', 'PATCH', 'PUT', 'POST', 'DELETE'])"
            src="../../assets/images/edit.svg" alt="Edit" /> -->
        </template> 
        <template #cell(flowId)="data">
          <span v-bind:id="data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-flowId'">
            {{data.value}}
          </span>
          <!-- WIP. For now no editing. WIP. -->
          <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-flowId', 'input')">
            <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/saveIcon.svg' />
            <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/edit.svg' />
          </a> -->
        </template>
        <template #cell(endpoint)="data">
          <span v-bind:id="data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-endpoint'">
            {{data.value}}
          </span>
          <!-- WIP. For now no editing. WIP. -->
          <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-endpoint', 'input')">
            <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/saveIcon.svg' />
            <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/edit.svg' />
          </a> -->
        </template>
        <template #cell(targetServer)="data">
          <span v-bind:id="data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-targetServer'">
            {{data.value}}
          </span>
          <!-- WIP. For now no editing. WIP. -->
          <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-targetServer', 'select', ['true', 'false'])">
            <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/saveIcon.svg' />
            <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/edit.svg' />
          </a> -->
        </template>
        <template #cell(isEnabled)="data">
          <span v-bind:id="data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-isEnabled'">
            {{data.value}}
          </span>
          <!-- WIP. For now no editing. WIP. -->
          <!-- <a @click="data.item.editing = !data.item.editing;"  v-b-tooltip.click.html="generateTipData(data.item.id + '-' + data.item.id + '-' + data.item.proxyId + '-' + data.item.flowId + '-isEnabled', 'select', ['true', 'false'])">
            <img v-if="data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/saveIcon.svg' />
            <img v-if="!data.item.editing" class="gateway__tool-button ml-1" 
            src='../../assets/images/edit.svg' />
          </a> -->
        </template>
        <template #cell(tools)="data">

        </template> 
      </b-table>
    </div>
    <div v-if="activeHref && revision && addEndpoint">
      <gateway-add-endpoint :revision="revision" :environment="activeEnvironment" :targetServers="targetServers" @refresh-gateway="getRevision((Number(data.currentRevision.revision) + 1).toString()); $emit('refresh-gateway', null); addEndpoint = false;"></gateway-add-endpoint>
    </div>
  </div>
</template>
<!-- End Template -->

<!-- Scripts -->
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Dropdown from "vue-simple-search-dropdown";
import GatewayAddEndpoint from "./GatewayAddEndpoint.vue";

Vue.component('gateway-add-endpoint', GatewayAddEndpoint);
Vue.use(VueToast);
Vue.use(Loading);

export default {
  name: "GatewayTable",
  components: { Dropdown },
  data() {
    return {
      // View State & Init
      loading: true,
      viewReady: false,

      // Revision Datas
      revision: null,

      // Gateway Inspect Table Fields
      gatewayInspectTableFields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'proxyId',
          label: 'Base Href',
        },
        {
          key: 'revision',
          label: 'Revision',
          sortable: true,
        },
        {
          key: 'tools',
          label: '',
        }
      ],

      // Data
      gatewayInspectData: [],

      // Gateway Table Fields
      gatewayTableFields: [
        {
          key: 'flowId',
          label: 'Flow ID',
          sortable: true,
        },
        {
          key: 'method',
          label: 'Method',
          sortable: true,
        },
        {
          key: 'quota',
          label: 'Rate Limiting',
        },
        {
          key: 'targetServer',
          label: 'Target Server',
        },
        {
          key: 'endpoint',
          label: 'Gateway Endpoint',
          sortable: true,
        },
        {
          key: 'tools',
          label: '',
        }
      ],

      // Gateway Data
      gatewayData: []
    };
  },
  props: ["data", "activeEnvironment", "activeHref", "addEndpoint", "targetServers"],

  created() {
    this.onInit();
  },

  methods: {
    async onInit() {
      if (!this.$auth.isAuthenticated) {
        return;
      }

      // Set Latest & Current Revision (Can easily extend to all)
      this.gatewayInspectData = [ 
        {
          id: this.data.id + " - Last Edit",
          isLatestDeployed: this.data.isLatestDeployed,
          proxyId: this.data.currentRevision.basePath,
          revision: this.data.currentRevision.revision,
          description: `${this.data.currentRevision.id} - Revision ${this.data.currentRevision.revision}`,
        }
      ]

    },

    async getRevision(revision) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;

      var request = new Request(
        config.OPERATIONS_SERVICE + `/environments/${this.activeEnvironment.id}/apis/${this.data.id}/revisions/${revision}?`, 
        {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const response = await fetch(request);
        if (response.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (response.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if (response.status == 503) {
          return this.getRevision(revision);
        }
        if (response.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        } else {
          // Page can be interacted with
          this.loading = false;

          // Gateway List Processing
          this.revision = await response.json();
          this.gatewayData = []; // Reset each request

          Array.isArray(this.revision.flows) ? this.revision.flows.forEach((flow) => {
            this.gatewayData.push({
              flowId: flow.name,
              method: flow.method,
              quota: flow.quota,
              targetServer: flow.targetServer,
              endpoint: flow.pattern,
            });
          }) : null;
        }
      } catch (tex) {
  
        Vue.$toast.open({message: 'Failed to get revision due to an error.', type: 'error'});
      }
    },

    focusBaseHref(val) {
      if (val.revision) {
        this.getRevision(val.revision);
        this.$emit('selected-href', val);
        this.$set(this, 'activeHref', val);
      }
    },

    editProperty(target, data, property) {
      const element = document.getElementById(property);
      if (element) {
        element.disabled = false;
        const event = new MouseEvent('dblclick');
        element.dispatchEvent(event);
        element.dispatchEvent(event);
      }
    },

    generateTipData(id, type, options = null) {
      if (type && type.toLowerCase() === 'select') {
        return `
          <select>
            ${options.map((val) => `<option id="${val}" name="${val}">${val}</option>`)}
          </select>
          `
      } else if (type && type.toLowerCase() === 'input') {
        return '<input>';
      }
    },
    
    resetState() {
      this.$set(this, 'activeHref', null);
    }
  },
  watch: {},
};
</script>
<!-- End Scripts -->

<!-- Styles -->
<style lang="scss" scoped>
.gateway-table-menu {
  a {
    color: rgb(37, 169, 202);
    display: flex;
    align-items: center;
    margin-top: 15px;
    text-decoration: none;
    transition: color 500ms;

    &:hover {
      color: rgb(24, 194, 236);
    }
  }

  .gateway__method-bubble {
    text-decoration: none;
    color: white;
    padding: 5px;
    background-color: #222222;
    border-radius: 2px;
  }

  .gateway__get-bubble {
    background-color: #66BE6D;
  }

  .gateway__delete-bubble {
    background-color: #F27778;
  }

  .gateway__patch-bubble {
    background-color: #eaf7ff;
  }

  .gateway__post-bubble {
    background-color: #484848;
  }

  .gateway__put-bubble {
    background-color: #1dd8f6;
  }

  .loader {
    border: 3px solid #f3f3f3; /* Light grey */
    border-top: 3px solid rgba(37, 168, 202, 0.8); /* Blue */
    border-radius: 50%;
    width: 45px;
    height: 45px;
    animation: spin 1.5s linear infinite;
  }

  .accordion-heading {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .collapse.in {
    overflow: visible;
  }

  .ml-a {
    margin-left: auto;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<!-- End Styles -->
